var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import DataForm from "~/components/common/data-form.vue";
import { Dependencies } from "~/core/decorator";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { Prop, Emit } from "vue-property-decorator";
import { CaseInfoDistributeService } from "~/services/business-service/caseinfo-distribute.service";
var CollectorAllocate = /** @class */ (function (_super) {
    __extends(CollectorAllocate, _super);
    function CollectorAllocate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        return _this;
    }
    CollectorAllocate.prototype.onPreStep = function () { };
    CollectorAllocate.prototype.close = function () { };
    CollectorAllocate.prototype.submit = function () {
        var _this = this;
        this.loading.state = true;
        this.caseInfoDistributeService.distributedCasesConfirm(this.distributeConfigModel).subscribe(function (data) {
            _this.$message.success("案件分配成功!");
            _this.loading.state = false;
            _this.close();
        }, function (error) {
            _this.$message.error(error.msg);
            _this.loading.state = false;
        });
    };
    __decorate([
        Dependencies(CaseInfoDistributeService)
    ], CollectorAllocate.prototype, "caseInfoDistributeService", void 0);
    __decorate([
        Prop()
    ], CollectorAllocate.prototype, "distributeConfigModel", void 0);
    __decorate([
        Prop()
    ], CollectorAllocate.prototype, "telNumber", void 0);
    __decorate([
        Emit("preStep")
    ], CollectorAllocate.prototype, "onPreStep", null);
    __decorate([
        Emit("close")
    ], CollectorAllocate.prototype, "close", null);
    CollectorAllocate = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                DataGrid: DataGrid,
                DataGridItem: DataGridItem,
            },
        })
    ], CollectorAllocate);
    return CollectorAllocate;
}(Vue));
export default CollectorAllocate;
